import { render, staticRenderFns } from "./ArtistConfirmation.vue?vue&type=template&id=6c28ece2&"
import script from "./ArtistConfirmation.vue?vue&type=script&lang=js&"
export * from "./ArtistConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports